import React from 'react';


class SideMenu extends React.Component {

    constructor(props) {
        super(props);
        this.role = localStorage.getItem("role");
        
    }

    render(props) {
        return (
            <aside className="main-sidebar sidebar-dark-primary elevation-4" style={{"text-transform": "uppercase"}}>

                <div className="sidebar">


                    <nav className="mt-2">
                        <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu"
                            data-accordion="false">
                            <li className="nav-item">
                                <a href="/anasayfa" className={this.props.home + " nav-link"}>
                                    <i className="nav-icon fas fa-home"/>
                                    <p>
                                        Anasayfa
                                    </p>
                                </a>
                            </li>
                            <li className="nav-item" style={(this.role !== "4") ? {display: "Block"} : {display: "None"}}>
                                <a href="#" className={this.props.gemiyuklendi + " nav-link"}>
                                    <i className="nav-icon fas fa-chart-pie"></i>
                                    <p>
                                        Gemi Yüklendi Listesi
                                        <i className="right fas fa-angle-left"></i>
                                    </p>
                                </a>
                                <ul className="nav nav-treeview" style={this.props.gemiyuklendiacik}>
                                    <li className="nav-item">
                                        <a href="/gemiyuklendihepsi"
                                           className={this.props.gemiyuklendihepsi + " nav-link"}>
                                            <i className="far fa-circle nav-icon"></i>
                                            <p>Hepsi</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/gemiyuklendiithalat"
                                           className={this.props.gemiyuklendiithalat + " nav-link"}>
                                            <i className="far fa-circle nav-icon"></i>
                                            <p>İthalat</p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/gemiyuklendiihracat"
                                           className={this.props.gemiyuklendiihracat + " nav-link"}>
                                            <i className="far fa-circle nav-icon"></i>
                                            <p>İhracat </p>
                                        </a>
                                    </li>
                                </ul>
                            </li>


                            <li className="nav-item" style={(this.role !== "4") ? {display: "Block"} : {display: "None"}}>
                                <a href="/zrapor"
                                   className={this.props.zrapor + " nav-link"}>
                                    <i className="nav-icon fas fa-archive"/>
                                    <p>
                                        Z Rapor
                                    </p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/arsiv" style={(this.role === "1") ? {display: "Block"} : {display: "None"}}
                                   className={this.props.arsiv + " nav-link"}>
                                    <i className="nav-icon fas fa-archive"/>
                                    <p>
                                        Arşiv
                                    </p>
                                </a>
                            </li>
                            <li className="nav-item" style={(this.role !== "4") ? {display: "Block"} : {display: "None"}}>
                                <a href="/ekodemeplakali" className={this.props.ekodemeplakali + " nav-link"}>
                                    <i className="nav-icon fas fa-money-bill-wave"/>
                                    <p>
                                        Ek Ödeme
                                    </p>
                                </a>
                            </li>

                            <li className="nav-item" style={(this.role === "1") ? {display: "Block"} : {display: "None"}}>
                                <a href="#" className={this.props.yonetim + " nav-link"}>
                                    <i className="nav-icon fas fa-chart-pie"></i>
                                    <p>
                                        Yönetim
                                        <i className="right fas fa-angle-left"></i>
                                    </p>
                                </a>
                                <ul className="nav nav-treeview" style={this.props.yonetimacik}>
                                    <li className="nav-item"
                                        style={(this.role === "1") ? {display: "Block"} : {display: "None"}}>
                                        <a href="/kullanici" className={this.props.kullanici + " nav-link"}>
                                            <i className="nav-icon fas fa-user"/>
                                            <p>
                                                Kullanıcılar
                                            </p>
                                        </a>
                                    </li>
                                    <li className="nav-item"
                                        style={(this.role === "1") ? {display: "Block"} : {display: "None"}}>
                                        <a href="/firma" className={this.props.firma + " nav-link"}>
                                            <i className="nav-icon fas fa-truck-moving"/>
                                            <p>
                                                Firma
                                            </p>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/fiyatlandirma"
                                           style={(this.role === "1") ? {display: "Block"} : {display: "None"}}
                                           className={this.props.fiyatlandirma + " nav-link"}>
                                            <i className="nav-icon fas fa-money-bill-wave"/>
                                            <p>
                                                Fiyatlandırma
                                            </p>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <a href="/pendikithalat" className={this.props.pendikithalat + " nav-link"}
                                   style={(this.role === "1" || this.role === "2") ? {display: "Block"} : {display: "None"}}>
                                    <i className="nav-icon fas fa-truck-loading"/>
                                    <p>
                                        Pendik Ithalat
                                    </p>
                                </a>
                            </li>
                            <li className="nav-item"
                                style={(this.role === "1" || this.role === "2") ? {display: "Block"} : {display: "None"}}>
                                <a href="/pendikihracat" className={this.props.pendikihracat + " nav-link"}>
                                    <i className="nav-icon fas fa-truck-loading"/>
                                    <p>
                                    Pendik Ihracat
                                    </p>
                                </a>
                            </li>
                            <li className="nav-item"
                                style={(this.role === "1" || this.role === "3") ? {display: "Block"} : {display: "None"}}>
                                <a href="/yalovaithalat" className={this.props.yalovaithalat + " nav-link"}>
                                    <i className="nav-icon fas fa-truck-loading"/>
                                    <p>
                                        Yalova Ithalat
                                    </p>
                                </a>
                            </li>
                            <li className="nav-item"
                                style={(this.role === "1" || this.role === "3") ? {display: "Block"} : {display: "None"}}>
                                <a href="/yalovaihracat" className={this.props.yalovaihracat + " nav-link"}>
                                    <i className="nav-icon fas fa-truck-loading"/>
                                    <p>
                                        Yalova Ihracat
                                    </p>
                                </a>
                            </li>
                            <li style={{display: "None"}} className="nav-item">
                                <a href="/sorgulama" className={this.props.sorgulama + " nav-link"}>
                                    <i className="nav-icon fas fa-truck-loading"/>
                                    <p>
                                        Sorgulama
                                    </p>
                                </a>
                            </li>


                            <li className="nav-item" style={(this.role === "1" || this.role === "4") ? {display: "Block"} : {display: "None"}}>
                                <a href="#" className={this.props.muhasebe + " nav-link"}>
                                    <i className="nav-icon fas fa-chart-pie"></i>
                                    <p>
                                        Muhasebe
                                        <i className="right fas fa-angle-left"></i>
                                    </p>
                                </a>
                                <ul className="nav nav-treeview" style={this.props.muhasebeacik}>
                                    <li className="nav-item"
                                        style={(this.role === "1" || this.role === "4") ? {display: "Block"} : {display: "None"}}>
                                        <a href="/muhasebefirma" className={this.props.muhasebefirma + " nav-link"}>
                                            <i className="nav-icon fas fa-truck-moving"/>
                                            <p>
                                                Muhasebe Firma
                                            </p>
                                        </a>
                                    </li>
                                    <li className="nav-item"
                                        style={(this.role === "1" || this.role === "4") ? {display: "Block"} : {display: "None"}}>
                                        <a href="/gider" className={this.props.gider + " nav-link"}>
                                            <i className="nav-icon fas fa-money-bill"/>
                                            <p>
                                                Fatura Gider
                                            </p>
                                        </a>
                                    </li>
                                    <li className="nav-item"
                                        style={(this.role === "1" || this.role === "4") ? {display: "Block"} : {display: "None"}}>
                                        <a href="/kasa" className={this.props.kasa + " nav-link"}>
                                            <i className="nav-icon fas fa-money-bill"/>
                                            <p>
                                                Kasa
                                            </p>
                                        </a>
                                    </li>
                                    <li style={{display: "None"}} className="nav-item">
                                        <a href="/muhasebe" className={this.props.muhasebe + " nav-link"}>
                                            <i className="nav-icon fas fa-money-bill"/>
                                            <p>
                                                Muhasebe
                                            </p>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <a href="/" className={" nav-link"}>
                                    <i className="nav-icon fas  fa-sign-out-alt"/>
                                    <p>
                                        Çıkış
                                    </p>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </aside>
        );
    }
}

export default SideMenu;
